import {useAuth} from "../components/auth/AuthContext";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {OAuthStore} from "../components/auth/store";
import {AccountSubdomainStore} from "../components/auth/subdomain";

export type UseLogoutReturn = {
  loading: boolean;
  error: boolean;
  logout?: () => Promise<string>;
}

export const useLogout = (): UseLogoutReturn => {
  const {loading: loadingUser, user, signOut} = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const idTokenHint = searchParams.get("user_hint");
  const redirectUri = searchParams.get("post_logout_redirect_uri");

  useEffect(() => {
    if (user) {
      setError(user.uid !== idTokenHint);
      setLoading(false);
    }
    if (!user && !loadingUser) {
      setLoading(false);
    }

  }, [user, loadingUser]);

  let logout = undefined;

  if (!error && !loading) {
    logout = async () => {
      await signOut()
      OAuthStore.clear();
      AccountSubdomainStore.clear();
      return getRedirectUri(redirectUri);
    };
  }

  return {
    loading,
    error,
    logout,
  }
};

const getRedirectUri = (redirectUri: string | null) => {
  if (redirectUri && postLogoutRedirectUris.includes(redirectUri)) {
    return redirectUri;
  }
  return postLogoutRedirectUris[0];
}

const postLogoutRedirectUris = [
  "https://wakelet.com/accounts/logout",
  "https://staging.wakelet.com/accounts/logout",
  "https://localhost.wakelet.com/accounts/logout",
  "http://localhost.wakelet:1235/accounts/logout",
  "http://localhost.wakelet:3000/accounts/logout",
  "https://alpha.wakelet.com/accounts/logout",
    "com.wakelet://postlogout",
    "com.wakelet.wakelet.oauth://logout"
]
